import { render, staticRenderFns } from "./createAccountNoBeneficario.vue?vue&type=template&id=47f47a7e&"
import script from "./createAccountNoBeneficario.vue?vue&type=script&lang=ts&"
export * from "./createAccountNoBeneficario.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports